import { HateoasResource } from '@lagoshny/ngx-hateoas-client';
import { CompanyOwned } from '../company/company-models.model';
import { LayerFeaturesCharacteristics } from './layer-feature-characteristics-code.model';

@HateoasResource('layerfeaturescode')
export class LayerFeaturesCode extends CompanyOwned {
  public kenmerken!: LayerFeaturesCharacteristics[];
  public naam!: string;
  public verborgen!: boolean;
}
